module.exports = __webpack_public_path__ + "static/media/welcome_page_full.082eee59.png";